<template>
    <modal ref="modalHistorialAceptacion" titulo="Historial de aceptación de FAQs" icon="aprobar" no-aceptar no-cancelar tamano="modal-xl">
        <div class="row mx-0">
            <div class="col-3 border-right custom-scroll overflow-auto" style="height:calc(100vh - 418px)">
                <div class="row mx-0">
                    <img :src="user.foto" class="obj-cover rounded-circle border" width="60" height="60" />
                    <div class="col pl-2 pr-0 f-14">
                        <p class="text-general f-600">{{ user.tipo_nombre }}</p>
                        <p class="text-general2 mt-1">{{ user.nombre }}</p>
                        <p class="text-general2 mt-1">{{ user.nombre_cedis }}</p>
                    </div>
                </div>
                <div class="row mx-0 my-3">
                    <div class="col-12 text-general f-500 f-14 px-0">
                        Fechas de aceptación
                    </div>
                </div>
                <div class="row mx-0">
                    <el-tooltip v-for="(item, a) in aceptadas" :key="a" placement="bottom" :content="`Aceptadas vía ${nombreAceptada(item)}`" effect="light">
                        <div :class="`col-11 cr-pointer d-middle border mt-2 py-1 ${aceptada.fecha == item.fecha ? 'bg-light-f5' : ''} br-12`" @click="aceptadaSeleccionada(item)">
                            <div :class="`${aceptada.fecha == item.fecha ? 'bg-general' : ''} br-20`" style="width:5px;height:39px;" />
                            <p class="col pl-2 text-general f-15 f-600">
                                {{ formatearFecha(item.fecha,'D MMM Y hh:mmA') }}
                            </p>
                            <i :class="iconoAceptada(item)" class="text-general f-20" />
                        </div>
                    </el-tooltip>
                </div>
            </div>
            <div v-if="aceptada.fecha != ''" class="col px-0">
                <div class="row mx-0 border-bottom">
                    <div :class="`col-auto px-3 py-2 cr-pointer ${ active_tab == 1 ? 'active-tab' : 'text-general2'}`" @click="active_tab = 1">
                        Términos y condiciones
                    </div>
                    <div :class="`col-auto px-3 py-2 cr-pointer ${ active_tab == 2 ? 'active-tab' : 'text-general2'}`" @click="active_tab = 2">
                        Política de privacidad
                    </div>
                </div>
                <div class="custom-scroll overflow-auto" :style="altoFaqs">
                    <section class="px-4 pt-4">
                        <p class="text-general f-22 f-600">{{ active_tab == 1 ? 'Términos y Condiciones de Uso de Plataforma' : 'Política de Protección y Tratamiento de Datos Personales' }}</p>
                        <div class="row mx-0 py-3" />
                        <div v-for="(data, t) in tabSeleccionada" :key="t" class="row mx-0 mt-3">
                            <div class="col-12 px-0 text-general f-17 f-600">
                                {{ data.titulo }}
                            </div>
                            <div class="col-12 px-0 mt-2 text-general ">
                                {{ data.texto.texto }}
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import FaqsAceptadas from "~/services/faqs/faqs_aceptadas";
const obj ={
    0: {
        icono:'',
        nombre:''
    },
    1: {
        icono:'icon-web',
        nombre:'Web'
    },
    2: {
        icono:'icon-android',
        nombre:'Android'
    },
    3: {
        icono:'icon-ios',
        nombre:'IOS'
    },
}
export default {
    data(){
        return {
            url_image: 'https://img.freepik.com/foto-gratis/joven-confiado_1098-20868.jpg?size=626&ext=jpg',
            active_tab: 1,
            fecha_activa: 1,
            aceptadas: [],
            altoFaqs: 'height:calc(100vh - 459px)',
            terminos: [
                {
                    titulo: 'Información',
                    contenido_texto: 'Es una sociedad constituida conforme a las leyes colombianas, identificada con NIT: 900843898-9, con domicilio en la ciudad de Bucaramanga., que para los efectos de los presentes términos se denominará EL OPERADOR.'
                },
                {
                    titulo: 'Naturaleza jurídica',
                    contenido_texto: 'Los presentes términos y condiciones de uso regulan la relación contractual de carácter comercial que une a los Consumidores que acceden a la plataforma virtual y al OPERADOR, especialmente en la autorización de uso que otorga éste en favor de aquel.'
                },
                {
                    titulo: 'Definiciones',
                    contenido_texto: 'Mensajes de datos: La información generada, enviada, recibida, almacenada o comunicada por medios electrónicos, ópticos o similares, como pudieran ser, entre otros, el Intercambio Electrónico de Datos (EDI), Internet, el correo electrónico, el telegrama, el télex o el telefax (Ley 527 de 1999 art. 2 lit. a). Comercio Electrónico: Comprende el envío, transmisión, recepción, almacenamiento de mensajes de datos por vía electrónica. Las dudas que surjan respecto de la eficacia y validez de los mensajes de datos y demás actividades vinculadas al comercio electrónico se interpretarán de conformidad con la ley 527 de 1999. Cookies: Cadenas de texto enviadas virtualmente que son almacenadas por el uso de La Plataforma por el Operador, para la consulta de las actividades y preferencias de los usuarios. Consumidores: Toda persona natural que, como destinatario final, use La Plataforma para solicitar por medio de ésta un mandato remunerado, cuyo encargo consiste en la celebración de un contrato de compraventa o cualquier otro tipo de contrato lícito, con el fin de adquirir bienes o servicios. Mandatario: Persona natural que acepta realizar la gestión del encargo solicitado por el Consumidor a través de la Plataforma. El Mandatario actúa por cuenta y riesgo propio y libera de cualquier tipo de responsabilidad que pueda surgir durante la prestación del servicio al Consumidor. Operador de La Plataforma: Encargado de administrar operativamente y funcionalmente la Plataforma, representado para los efectos de los presentes términos por RAPPI S.A.S., o por la persona natural o jurídica que ésta designe. Contrato de mandato remunerado celebrado por medios electrónicos: Aquel acuerdo de voluntades celebrado entre el Consumidor y el Mandatario, por medio del cual el Consumidor solicita, a través de la Plataforma, la gestión de un encargo al Mandatario, obligándose este último a cumplir con dicho encargo por cuenta y riesgo propio, a cambio de recibir una remuneración como contraprestación. Datos personales: Es toda información que permite identificar o hacer identificable a una persona física. Interacción en La Plataforma: Facultad de acceso por parte de los Consumidores para conocer los productos y servicios exhibidos por el OPERADOR, la publicidad puesta a disposición en la Plataforma y manifestar su voluntad de solicitar un encargo. Mayor de edad: Persona natural mayor de dieciocho (18) años. Mensajes de texto (SMS): Todas las comunicaciones y/o notificaciones enviadas por Rappi por medio de mensaje de texto (SMS) serán enviadas desde el número 85877. Adicionalmente, Rappi podrá comunicarse con el usuario a través de otros canales como Whatsapp y cualquier otro medio de acceso al usuario siempre y cuando éste haya compartido la información con Rappi mediante su previa autorización a la Política de tratamiento de datos personales. Rappi únicamente será responsable por las comunicaciones y/o notificaciones enviadas desde este número y/o canales adicionales que establezca para dicho fin'
                },
                {
                    titulo: 'Objeto',
                    contenido_texto: 'Los presentes términos y condiciones regulan la autorizacion de uso que otorga el operador a los consumidores, para que éstos ingresen a la plataforma virtual, se informen sobre los productos de consumo exhibidos, para que sean utilizados como referencia y pueden solicitar la gestion de un encargo pór medio de un contrato de mandato con el mandatario.'
                },
                {
                    titulo: 'Plataforma tecnologica',
                    contenido_texto: 'Es una plataforma que permite su uso gratuito por varios medios a saber. i) portal web: www.rappi.com, www.rappi.tienda, www.rappi.co, www.rappi.tienda.com'
                },
                {
                    titulo: 'Modificación',
                    contenido_texto: 'El operador podrá modificar autonomamente y en cualquier momento en aspectos formales, procedimentales o sustanciales los presentes terminos y condiciones de uso de la Plataforma, los cuales seran actualizados y puestos a disposicion de los consumidores en la plataforma.'
                }
            ],
            user: {
                id: null,
                nombre: null,
                foto: null,
                nombre_cedis: null,
                tipo_nombre: null,
            },
            aceptada: {
                fecha: '',
                origen: null,
                terminos: [],
                politicas: [],
            }
        }
    },
    computed: {
        tabSeleccionada(){
            return this.active_tab == 1 ? this.aceptada.terminos : this.aceptada.politicas
        }
    },
    mounted(){
        if(window.innerHeight <= 680){
            this.altoFaqs = 'height:calc(100vh - 323px)'
        }
        this.terminos[0].contenido_texto = `${this.$config.proyecto} es una sociedad constituida conforme a las leyes colombianas, identificada con NIT: 900843898-9, con domicilio en la ciudad de Bucaramanga., que para los efectos de los presentes términos se denominará EL OPERADOR.`
    },
    methods: {
        toggle(row){
            this.user.id = row.id
            this.user.nombre = row.nombre
            this.user.foto = row.foto
            this.user.nombre_cedis = row.nombre_cedis
            this.user.tipo_nombre = row.tipo_nombre
            this.limpiar()
            this.getFaqsAceptadas()
            this.$refs.modalHistorialAceptacion.toggle();
        },
        async getFaqsAceptadas(){
            try {
                const { data } = await FaqsAceptadas.getFaqsAceptadasUser(this.user.id)

                this.aceptadas = data.aceptadas
            } catch (error){
                console.log(error);
            }
        },
        iconoAceptada({ origen }){
            return obj[origen].icono ?? obj[0].icono
        },
        nombreAceptada({ origen }){
            return obj[origen].nombre ?? obj[0].nombre
        },
        aceptadaSeleccionada(aceptada){
            this.aceptada = aceptada
        },
        limpiar(){
            this.aceptada = {
                fecha: '',
                origen: null,
                terminos: [],
                politicas: [],
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.active-tab{
    color: var(--text-general) !important;
    font-weight: 500;
    border-bottom: 3px solid var(--text-general) !important;
}
</style>
